window.$= jQuery;
